/** Post-save success dialog — printable slip + follow-up actions. */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MobileSlip } from "@/components/PrintDocs";
import { CheckCircle2, Home } from "lucide-react";

export function RegistrationSuccess({ result, form, user, onOpenChange, onAnother, onDone }) {
  return (
    <Dialog open={!!result} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[92vh] overflow-y-auto" data-testid="new-reg-success">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <CheckCircle2 className="w-6 h-6 text-primary" /> Registration complete
          </DialogTitle>
          <DialogDescription>Print, download or share the slip below.</DialogDescription>
        </DialogHeader>
        {result && (
          <div className="space-y-4">
            <MobileSlip
              haatName={result.receipt?.haat_name || user?.haat_name || "AnimalMela"}
              registrationNumber={result.animal.registration_number}
              receiptNumber={result.receipt.receipt_number}
              amount={result.receipt.amount}
              feeBreakdown={result.receipt.fee_breakdown}
              paymentMode={form.payment.payment_type}
              sellerName={form.seller.name}
              sellerMobile={form.seller.mobile}
              sellerVillage={form.seller.address}
              animalType={form.animals[0]?.animal_type}
              animalBreed={form.animals[0]?.breed === "Other" ? form.animals[0]?.breed_custom : form.animals[0]?.breed}
              animalGender={form.animals[0]?.gender}
              animalColour={form.animals[0]?.colour === "Other" ? form.animals[0]?.colour_custom : form.animals[0]?.colour}
              salePrice={Number(String(form.animals[0]?.sale_price || "").replace(/\D/g, "") || 0)}
              animalCount={form.animals.length}
              helperName={result.receipt?.helper_name || user?.name}
              subscriberName={result.receipt?.owner_name || user?.subscriber_name}
              passNumber={result.gatepass.pass_number}
              qrPayload={result.gatepass.qr_payload}
              animalId={result.animal.registration_number}
              entryStatus="issued"
              exitStatus="pending"
              purchaserName={form.purchaser?.name}
              purchaserMobile={form.purchaser?.mobile}
              purchaserVillage={form.purchaser?.address}
              saleCompleted={!!form.purchaser?.name}
            />

            <div className="grid grid-cols-2 gap-2 pt-2 no-print">
              <Button variant="outline" className="rounded-full" onClick={onAnother} data-testid="new-reg-another">
                Register another
              </Button>
              <Button className="am-btn-primary" onClick={onDone}>
                <Home className="w-4 h-4 mr-1" /> Done
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
